import React from 'react';
import '../styles/Technologies.css';
import {
  FaHtml5,
  FaCss3Alt,
  FaBootstrap,
  FaNodeJs,
  FaReact,
  FaPhp,
  FaGithub,
  FaGitlab,
  FaAws,
} from 'react-icons/fa';
import {
  SiMysql,
  SiMongodb,
  SiPostgresql,
  SiWordpress,
  SiCloudflare,
  SiFirebase,
} from 'react-icons/si';

const CpanelIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    className="tech-icon cpanel"
    fill="currentColor"
  >
    <path d="M4 32C4 17.64 17.64 4 32 4s28 13.64 28 28-13.64 28-28 28S4 46.36 4 32zm18.5 7h-6.5a2.5 2.5 0 1 1 0-5h6.5c4.5 0 8.5-3.58 8.5-8 0-4.42-4-8-8.5-8H11.5a2.5 2.5 0 1 1 0-5h11.5c7.2 0 13.5 5.48 13.5 13s-6.3 13-13.5 13zm24 0H35c-1.66 0-3 1.34-3 3s1.34 3 3 3h11.5c7.2 0 13.5-5.48 13.5-13s-6.3-13-13.5-13H35c-1.66 0-3 1.34-3 3s1.34 3 3 3h11.5c4.5 0 8.5 3.58 8.5 8 0 4.42-4 8-8.5 8z" />
  </svg>
);

const WhmcsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    className="tech-icon whmcs"
    fill="currentColor"
  >
    <circle cx="256" cy="256" r="256" fill="#6C91BF" />
    <text
      x="50%"
      y="55%"
      textAnchor="middle"
      fill="#fff"
      fontSize="120"
      fontWeight="bold"
      fontFamily="Arial, sans-serif"
    >
      WHMCS
    </text>
  </svg>
);

const CentosWebPanelIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    className="tech-icon centos"
    fill="currentColor"
  >
    <circle cx="32" cy="32" r="30" fill="#6610f2" />
    <text
      x="50%"
      y="55%"
      textAnchor="middle"
      fill="#fff"
      fontSize="10"
      fontWeight="bold"
      fontFamily="Arial, sans-serif"
    >
      CentOS Web
    </text>
  </svg>
);

// Array de Tecnologias
const techs = [
  { name: 'HTML', icon: <FaHtml5 className="tech-icon html" /> },
  { name: 'CSS', icon: <FaCss3Alt className="tech-icon css" /> },
  { name: 'Bootstrap', icon: <FaBootstrap className="tech-icon bootstrap" /> },
  { name: 'React', icon: <FaReact className="tech-icon react" /> },
  { name: 'WordPress', icon: <SiWordpress className="tech-icon wordpress" /> },
  { name: 'Node.js', icon: <FaNodeJs className="tech-icon nodejs" /> },
  { name: 'PHP', icon: <FaPhp className="tech-icon php" /> },
  { name: 'MySQL', icon: <SiMysql className="tech-icon mysql" /> },
  { name: 'MongoDB', icon: <SiMongodb className="tech-icon mongodb" /> },
  { name: 'Postgres', icon: <SiPostgresql className="tech-icon postgres" /> },
  { name: 'GitHub', icon: <FaGithub className="tech-icon github" /> },
  { name: 'GitLab', icon: <FaGitlab className="tech-icon gitlab" /> },
  { name: 'AWS', icon: <FaAws className="tech-icon aws" /> },
  { name: 'Cloudflare', icon: <SiCloudflare className="tech-icon cloudflare" /> },
  
  { name: 'Firebase', icon: <SiFirebase className="tech-icon firebase" /> },
  { name: 'cPanel', icon: <CpanelIcon /> },
  { name: 'WHMCS', icon: <WhmcsIcon /> },
  { name: 'CWP', icon: <CentosWebPanelIcon /> },
];

function Technologies() {
  return (
    <section id="technologies" className="technologies-section">
      <h2 className="section-title">Tecnologias</h2>
      <div className="technologies-grid">
        {techs.map((tech, index) => (
          <div key={index} className="tech-card">
            {tech.icon}
            <span>{tech.name}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Technologies;
